import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiTagModule } from 'omnium-ui/tag';
import { InvestorStatusTagComponent } from '../investor-status-tag/investor-status-tag.component';
import { SummaryCardComponent } from '../summary-card/summary-card.component';

export type SummaryGridItemAside = {
  label: string;
  status: 'completed' | 'pending' | 'error' | 'to-correct' | 'todo';
};

export type SummaryGridItem = {
  key: string;
  label: string;
  value: string | number;
  investorStatusCode?: string | null;
  meta?: string;
  compactValue?: boolean;
  aside?: SummaryGridItemAside;
};

@Component({
  selector: 'dbw-summary-grid',
  imports: [OuiTagModule, InvestorStatusTagComponent, SummaryCardComponent],
  styleUrl: './summary-grid.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <section class="summary-grid">
      @for (item of items(); track item.key) {
        <dbw-summary-card
          [label]="item.label"
          [compactValue]="item.compactValue ?? false"
          [meta]="item.meta ?? ''"
        >
          @if (item.investorStatusCode !== undefined) {
            <dbw-investor-status-tag
              summaryValue
              [statusCode]="item.investorStatusCode"
            ></dbw-investor-status-tag>
          } @else {
            <span summaryValue>{{ item.value }}</span>
          }
          @if (item.aside) {
            <oui-tag
              summaryAside
              type="status"
              [status]="item.aside.status"
            >
              {{ item.aside.label }}
            </oui-tag>
          }
        </dbw-summary-card>
      }
    </section>
  `
})
export class SummaryGridComponent {
  readonly items = input.required<SummaryGridItem[]>();
}
